import React, { useState, useEffect, useContext, useRef } from 'react'
import './DealerBlock.scss'
import { Button } from '../../Forms/Forms'
import { useDispatch, useSelector } from 'react-redux'
import {
    setDealerDetails,
    setSelectedForfaitsToStore,
    setSelectedMandatoryAdditionalForfaitsToStore
} from '../../../redux-files/actions/action';
import { dealersPerPageContext } from '../context'
import CONSTANTS from '../../../Constants';
import { isMobile } from '../../../helpers/helpers';
import PopIn from '../../PopIn/PopIn';
import fetchApiData from '../../../apiHandlers/fetchApiData';
import moment from 'moment';
import "moment/min/locales";
import { pushEventToGTM } from '../../../helpers/trackerManager';

const DealerBlock = (props) => {
    const dispatch = useDispatch()
    const myRef = useRef(null)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const dealer = useSelector(state => state.ndel_store.dealer)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)

    const { MouseEnterDealerBlock, MouseLeaveDealerBlock, onDelaerClikced } = useContext(dealersPerPageContext)
    const [slots, setSlots] = useState([])
    const [showFilterPopin, setShowFilterPopin] = useState(false)

    useEffect(() => {
        // myRef.current !== null && myRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
        moment.locale(window.siteConfig['language']);
        dealer.editDealer && dealer.isFromAppointmentPage && getCreneauxDispo(new Date(), props.dealerID)
    }, [])
    const getCreneauxDispo = (newDate, dealerId = dealer.iD) => {
        const fetchSlots = new fetchApiData();
        fetchSlots.getCreneauxDispo(dealerId, newDate)
            .then(
                res => {
                    setSlots(JSON.parse(res.d)[0].days)
                })
            .catch(error => {
                console.error(error)
            });
    }
    const handlMouseEnterDealerBlock = (id) => {
        MouseEnterDealerBlock(id)
    }
    const handlMouseLeaveDealerBlock = () => {
        MouseLeaveDealerBlock()
    }
    const chooseDealer = () => {
        if (props.dealerID !== dealer.iD) {
            storeSelectedOperations.forEach(operation => {
                if (!operation.interventionForfaits[0].isConstructeur) {
                    operation.interventionForfaits[0].SubFunctionList[0].ForfaitList.forEach(forfait => forfait.isChecked=false)
                }
            })
            dispatch(setSelectedForfaitsToStore([]))
            dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
        }
        dispatch(setDealerDetails({
            iD: props.dealerID,
            geoID: props.dealerGeoID,
            name: props.dealerName,
            adress: props.dealerAddress,
            city: props.dealerCity,
            LCV: props.dealerLCV,
            PC: props.dealerPC,
            zip: props.dealerZipCode,
            listPremiumServices: props.dealerListeIdPremiumServices,
            position: props.dealerPosition,
            SelfReception: props.dealerSelfReception,
            culture: props.dealerCulture,
            editDealer: false,
            isFromAppointmentPage: false
        }))
        pushEventToGTM({
            pageName: 'dealer locator',
            eventAction: 'Redirection::Internal::Services',
            eventLabel: props.dealerName,
            eventCategory: 'Dealerlocator'
        })

    }
    const checkPCLCVCompatibility = () => {
        if ((vehicleInfo.LCV && props.dealerLCV) || (vehicleInfo.PC && props.dealerPC)) {
            chooseDealer()
        } else {
            if (props.isPCLCVFiltersActived) {
                setShowFilterPopin(true)
            } else {
                chooseDealer()
            }

        }
    }
    const handleClickOnDealer = (id) => {
        onDelaerClikced(id)
    }

    const mouseOnDealerClass = props.isOverDealer ? 'hover-dealer' : ''
    const dealerClickedClass = props.dealerIsClicked ? 'clicked-dealer' : ''
    const start = moment().format(' DD MMMM')
    const end = moment().add(6, 'days').format(' DD MMMM')
    //filterPopin for desktop for mobile check mapContainer file
    const popInFilterContent = <div className='content-warning-filters'>
        <p className='warning-main' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_filter_alert_main) }}></p>
        <div className='warning-list'>
            <p className='warning-second' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.vehicule_filter_alert_second) }}></p>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_warranty} </span> </li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_maintenance}</span></li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_recall_campain}</span></li>
            <li className='warning-item'><i className='icons cross-icon' /><span className='warning-label'>{CONSTANTS.LABELS.vehicule_filter_alert_package}</span></li>
        </div>
    </div>
    return (
        <>
            <div
                onClick={() => handleClickOnDealer(props.dealerID)}
                onMouseEnter={() => handlMouseEnterDealerBlock(props.dealerID)}
                onMouseLeave={() => handlMouseLeaveDealerBlock(props.dealerID)}
                className={`dealer-block  ${mouseOnDealerClass} ${dealerClickedClass}`}
                ref={props.dealerIsClicked ? myRef : null}
                tabIndex='0'
                onKeyDown = {(e)=> e.key === 'Enter' && handleClickOnDealer(props.dealerID)}
            >
                <h4 className={`dealer-name `}><span>{props.dealerName}</span></h4>
                <p className='dealer-distance'><span>{`${Math.round(props.dealerDistance * 10) / 10} ${CONSTANTS.LABELS.vehicule_step2_km2}`}</span></p>
                <p className='dealer-Address'><span>{`${props.dealerAddress} ${props.dealerZipCode} ${props.dealerCity}`}</span></p>
                {props.isPCLCVFiltersActived && <div className='dealer-type'>
                    <div>
                        {(props.dealerPC && !props.dealerLCV) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_descriptive}</p>}
                        {(props.dealerLCV && !props.dealerPC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_lcv_descriptive}</p>}
                        {(props.dealerLCV && props.dealerPC) && <p>{CONSTANTS.LABELS.dealer_locator_filter_pc_lvc_descriptive}</p>}
                    </div>
                </div>}
                {dealer.editDealer && dealer.isFromAppointmentPage &&
                    <div className='slots-infos'>
                        {slots.every(slot => slot.hours.length <= 0) ?

                            <div>{`${CONSTANTS.LABELS.dealer_quote_noslot.replace('[start]', start).replace('[end]', end)}`}</div>
                            : <div>{`${CONSTANTS.LABELS.dealer_quote_slots.replace('[start]', start).replace('[end]', end)}`}</div>
                        }
                    </div>
                }
                {!isMobile() && props.dealerIsClicked && <div className='button-choose-dealer'>
                    <Button
                        handlClick={checkPCLCVCompatibility}
                        isDisabled={false}
                    >
                        {CONSTANTS.LABELS.common_v2_choose}
                    </Button></div>}
            </div>
            {//for desktop
                showFilterPopin && <PopIn
                    title={CONSTANTS.LABELS.vehicule_filter_alert_title}
                    content={popInFilterContent}
                    primaryButtonLabel={CONSTANTS.LABELS.quote_alert_dealer}
                    secondaryButtonLabel={CONSTANTS.LABELS.common_v2_continue}
                    handlePrimaryButton={() => setShowFilterPopin(false)}
                    handleSecondaryButton={chooseDealer}
                />
            }
        </>
    )
}
export default DealerBlock